import { useEffect, useState, type ReactNode } from 'react';
import { Link, NavLink } from 'react-router';
import { Guitar, Menu, Moon, Sun, X } from 'lucide-react';
import { useAuth } from '../lib/auth';
export function Layout({ children }: { children: ReactNode }) {
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const [dark, setDark] = useState(() => localStorage.getItem('theme') === 'dark');
  useEffect(() => {
    document.documentElement.dataset.theme = dark ? 'dark' : 'light';
    localStorage.setItem('theme', dark ? 'dark' : 'light');
  }, [dark]);
  const links = [
    ['Browse', '/browse'],
    ['Artists', '/artists'],
    ['Categories', '/categories'],
    ['Requests', '/requests'],
  ];
  return (
    <>
      <header className="site-header">
        <Link className="brand" to="/">
          <span>
            <Guitar size={22} />
          </span>
          ChordVerse
        </Link>
        <nav className={open ? 'nav open' : 'nav'} aria-label="Main navigation">
          {links.map(([label, to]) => (
            <NavLink key={to} to={to!} onClick={() => setOpen(false)}>
              {label}
            </NavLink>
          ))}
          {user ? (
            <>
              <NavLink to="/dashboard">Dashboard</NavLink>
              {user.role !== 'USER' && <NavLink to="/reviewer">Review</NavLink>}
              {user.role === 'ADMIN' && <NavLink to="/admin">Admin</NavLink>}
              <button className="text-button" onClick={() => void logout()}>
                Log out
              </button>
            </>
          ) : (
            <>
              <NavLink to="/login">Log in</NavLink>
              <Link className="button small" to="/register">
                Join free
              </Link>
            </>
          )}
        </nav>
        <div className="header-actions">
          <button
            className="icon-button"
            aria-label="Toggle color theme"
            onClick={() => setDark(!dark)}
          >
            {dark ? <Sun /> : <Moon />}
          </button>
          <button
            className="icon-button mobile-menu"
            aria-label="Toggle menu"
            onClick={() => setOpen(!open)}
          >
            {open ? <X /> : <Menu />}
          </button>
        </div>
      </header>
      <main>{children}</main>
      <footer>
        <div>
          <Link className="brand" to="/">
            <Guitar /> ChordVerse
          </Link>
          <p>Play more. Share what you know.</p>
        </div>
        <div>
          <Link to="/about">Community guidelines</Link>
          <Link to="/browse">Browse songs</Link>
          <Link to="/requests">Song requests</Link>
        </div>
        <small>© {new Date().getFullYear()} ChordVerse</small>
      </footer>
    </>
  );
}
